<ng-container>
  <c-container
    [fluid]="true"
    class="border-0 app-topbar app-topbar-inner min-w-0"
    [class.px-3]="!showImaginusToolbar"
    [class.py-3]="!showImaginusToolbar"
    [class.d-flex]="!showImaginusToolbar"
    [class.align-items-center]="!showImaginusToolbar"
    [class.gap-2]="!showImaginusToolbar"
    [class.app-topbar-inner--imaginus]="showImaginusToolbar"
    [class.app-topbar-inner--imaginus-titled]="showImaginusToolbar && !!imaginusHeaderTitle"
    [style.min-height]="showImaginusToolbar ? null : '56px'"
  >
    <div class="app-topbar-shell-controls d-flex align-items-center flex-shrink-0 min-w-0 gap-1">
      <app-nav-back class="me-1" [compact]="true"></app-nav-back>
      <button
        type="button"
        class="btn btn-link team-header-menu-btn team-sidebar-toggle p-0"
        (click)="onHeaderSidebarToggle()"
        [attr.aria-label]="headerSidebarToggleLabel"
        [attr.title]="headerSidebarToggleLabel"
      >
        <svg cIcon name="cilMenu" size="lg" class="team-sidebar-icon"></svg>
      </button>
    </div>

    <div *ngIf="showImaginusToolbar && imaginusHeaderTitle" class="team-header-imaginus">
      <div
        class="team-header-imaginus__pill"
        [class.team-header-imaginus__pill--has-actions]="activeSessionActions.length"
      >
        <div class="team-header-imaginus__pill-body min-w-0"
          [class.team-header-imaginus__pill-body--clickable]="activeSessionActions.length"
          [attr.role]="activeSessionActions.length ? 'button' : null"
          [attr.tabindex]="activeSessionActions.length ? 0 : null"
          [attr.aria-label]="activeSessionActions.length ? primaryHeaderActionLabel : null"
          (click)="onPrimaryHeaderClick($event)"
          (keydown.enter)="onPrimaryHeaderClick($event)"
          (keydown.space)="onPrimaryHeaderClick($event)">
          <span class="team-header-imaginus__title" [attr.title]="imaginusHeaderTitle || null">{{ imaginusHeaderTitle }}</span>
          <span
            *ngIf="activeSessionSubtitle"
            class="team-header-imaginus__subtitle"
            [attr.title]="activeSessionSubtitle"
          >{{ activeSessionSubtitle }}</span>
        </div>
        <ng-container *ngIf="activeSessionActions.length">
          <span class="team-header-imaginus__pill-divider" aria-hidden="true"></span>
          <button
            *ngFor="let action of activeSessionActions; trackBy: trackByHeaderActionId"
            type="button"
            class="team-header-imaginus__pill-action"
            [class.team-header-imaginus__pill-action--labeled]="action.showLabel"
            [class.team-header-imaginus__pill-action--with-count]="action.badge != null && action.badge !== ''"
            [attr.aria-label]="action.ariaLabel || action.label"
            [attr.title]="action.title || action.label"
            (click)="onHeaderActionClick(action, $event)"
          >
            <svg *ngIf="action.iconPath" viewBox="0 0 24 24" aria-hidden="true">
              <path
                [attr.d]="action.iconPath"
                fill="none"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linejoin="round"
                stroke-linecap="round"
              />
            </svg>
            <span *ngIf="action.showLabel" class="team-header-imaginus__pill-action-label">{{ action.label }}</span>
            <span
              *ngIf="action.badge != null && action.badge !== '' && !action.showLabel"
              class="team-header-imaginus__pill-action-count"
            >{{ action.badge }}</span>
          </button>
        </ng-container>
      </div>
    </div>

    <c-header-nav class="d-flex align-items-center ms-auto flex-shrink-0 team-header-user-nav">
      <app-help-article-link
        class="me-2"
        [articleId]="help.QUICK_START_RECOMMENDED_FLOW"
        [ariaLabel]="'header.user_guide' | translate"
        [title]="'header.user_guide' | translate"
      />
      <c-dropdown
        variant="nav-item"
        [(visible)]="userMenuOpen"
        [popperOptions]="userMenuPopperOptions"
        class="team-header-user-dropdown"
      >
        <button
          type="button"
          [caret]="false"
          cDropdownToggle
          class="py-0 border-0 bg-transparent position-relative team-header-user-toggle"
          [attr.aria-label]="'header.open_user_menu' | translate"
          aria-haspopup="true"
          [attr.aria-expanded]="userMenuOpen"
        >
      <img
        [src]="headerAvatarUrl"
        class="rounded-circle border border-2 border-white shadow-sm"
        width="45"
        height="45"
        style="object-fit: cover; object-position: center;"
        loading="eager"
        alt="User avatar"
        (error)="onAvatarImageError()"
      />
      <span
        *ngIf="hasUnreadMail"
        class="position-absolute top-0 start-100 translate-middle team-header-unread-dot"
        aria-hidden="true"
      ></span>
    </button>

    <div cDropdownMenu class="user-menu-dropdown pt-0 border-0 shadow-lg">
         <div class="user-menu-dropdown__hero">
             <div class="position-relative d-inline-block mb-2">
               <img
                [src]="headerAvatarUrl"
                class="rounded-circle"
                width="80"
                height="80"
                style="object-fit: cover; object-position: center;"
                (error)="onAvatarImageError()"
              />
              <span class="position-absolute bottom-0 end-0 bg-success p-1 border border-2 border-white rounded-circle"></span>
            </div>
            <h5 class="fw-bold mb-0 user-menu-title">{{ team.team_name }}</h5>
            <div class="user-menu-sub small mb-3">{{ user.email }}</div>

            <button cDropdownItem class="btn btn-outline-secondary btn-settings-pill px-4 py-1 mx-auto d-inline-block w-auto"
                    [routerLink]="['/team', team.team_code, 'settings']">
              {{ 'header.team_settings' | translate }}
            </button>
         </div>

      <div class="user-menu-dropdown__scroll">
        <div class="user-menu-dropdown__actions">
          <a cDropdownItem (click)="OpenMailbox()" class="d-flex align-items-center px-4 py-2 dropdown-link">
            <div class="icon-wrapper bg-light text-primary rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
              <svg cIcon name="cilBell" size="md"></svg>
            </div>
            <div class="flex-grow-1 min-w-0">
              <span class="d-block fw-semibold">{{ 'header.notifications' | translate }}</span>
              <small *ngIf="hasUnreadMail" class="text-danger">{{ 'header.unread_notifications' | translate }}</small>
              <small *ngIf="!hasUnreadMail" class="text-muted">{{ 'header.no_new_notifications' | translate }}</small>
            </div>
            <span *ngIf="hasUnreadMail" class="team-header-menu-unread-badge">{{ 'header.unread_badge' | translate }}</span>
          </a>

          <a cDropdownItem [routerLink]="['/mailbox']" [queryParams]="{ team: team.team_code }" class="d-flex align-items-center px-4 py-2 dropdown-link">
            <div class="icon-wrapper bg-light text-primary rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
              <svg cIcon name="cilCreditCard" size="md"></svg>
            </div>
            <span class="fw-semibold">{{ 'header.billing_hub' | translate }}</span>
          </a>

          <a cDropdownItem routerLink="/help" target="_blank" rel="noopener" class="d-flex align-items-center px-4 py-2 dropdown-link">
            <div class="icon-wrapper bg-light text-info rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
              <svg cIcon name="cilDescription" size="md"></svg>
            </div>
            <span class="fw-semibold">{{ 'header.user_guide' | translate }}</span>
          </a>
        </div>

        <div class="user-menu-dropdown__accounts">
          <div class="user-menu-dropdown__accounts-head fw-bold">{{ 'header.switch_accounts' | translate }}</div>

          <div class="account-list px-1">
          <a cDropdownItem (click)="navigateToIdentity('user', user.email)" class="d-flex align-items-center px-3 py-2 rounded mb-1 account-item">
            <div class="avatar-small me-3 rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center" style="width: 32px; height: 32px;">
              <svg cIcon name="cilUser" size="sm"></svg>
            </div>
            <div>
              <div class="fw-bold text-dark" style="font-size: 0.9rem;">{{ 'header.personal_account' | translate }}</div>
              <div class="text-muted small" style="font-size: 0.75rem;">{{ user.firstname }} {{ user.lastname }}</div>
            </div>
          </a>

          <ng-container *ngFor="let t of team_list">
            <a *ngIf="t.team_code !== team.team_code && !t.disabled" cDropdownItem (click)="navigateToIdentity('team', t.team_code)" class="d-flex align-items-center px-3 py-2 rounded mb-1 account-item">
              <div class="avatar-small me-3 rounded-circle bg-primary text-white d-flex align-items-center justify-content-center" style="width: 32px; height: 32px;">
                <svg cIcon name="cilGroup" size="sm"></svg>
              </div>
              <div>
                <div class="fw-bold text-dark" style="font-size: 0.9rem;">{{ t.team_name }}</div>
                <div class="text-muted small" style="font-size: 0.75rem;">{{ 'layout.createTeam.accountTypeTeam' | translate }}</div>
              </div>
            </a>
          </ng-container>

          <a cDropdownItem (click)="openCreateTeamModal()" class="d-flex align-items-center px-3 py-2 rounded mb-1 account-item" style="cursor: pointer;">
            <div class="avatar-small me-3 rounded-circle text-primary border border-primary d-flex align-items-center justify-content-center" style="width: 32px; height: 32px; border-style: dashed !important; background-color: transparent;">
              <svg cIcon name="cilPlus" size="sm"></svg>
            </div>
            <div>
              <div class="fw-bold text-primary" style="font-size: 0.9rem;">{{ 'layout.createTeam.createNew' | translate }}</div>
            </div>
          </a>

          </div>
        </div>
      </div>

      <div class="border-top p-2 text-center bg-transparent">
        <button cDropdownItem (click)="onlogout()" class="btn btn-light btn-logout w-100 py-2 rounded border-0">
          <svg cIcon name="cilAccountLogout" class="me-2"></svg>
          {{ 'common.logout' | translate }}
        </button>
      </div>
    </div>
  </c-dropdown>
    </c-header-nav>
  </c-container>

</ng-container>

<div #modalTeleportTarget>
  <c-modal [(visible)]="isCreateTeamModalVisible" backdrop="static" alignment="center">
    <c-modal-header>
      <h5 cModalTitle>{{ 'layout.createTeam.title' | translate }}</h5>
      <button cButtonClose (click)="closeCreateTeamModal()"></button>
    </c-modal-header>
    <c-modal-body>
      <div class="mb-3">
        <label cLabel for="teamNameInput" class="fw-bold mb-2">{{ 'layout.createTeam.nameLabel' | translate }}</label>
        <input
          cFormControl
          id="teamNameInput"
          type="text"
          [(ngModel)]="newTeamName"
          [placeholder]="'layout.createTeam.namePlaceholder' | translate"
          (keyup.enter)="submitCreateTeam()"
        />
      </div>
    </c-modal-body>
    <c-modal-footer>
      <button cButton color="secondary" variant="ghost" (click)="closeCreateTeamModal()">{{ 'common.cancel' | translate }}</button>
      <button cButton color="primary" class="text-white" [disabled]="!newTeamName.trim() || isCreatingTeam" (click)="submitCreateTeam()">
        <c-spinner *ngIf="isCreatingTeam" size="sm" class="me-1"></c-spinner>
        {{ 'layout.createTeam.submit' | translate }}
      </button>
    </c-modal-footer>
  </c-modal>
</div>
